// extracted by mini-css-extract-plugin
export default {"root":"UserStatusBadge_root__7FBuO","status":"UserStatusBadge_status__stnBO","details":"UserStatusBadge_details__7JwOG"};